import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AccountAssessment, Assessment, AssessmentStatus } from '../../models/AssessmentModel';
import { PlatformApiService } from '../../services/platform-api.service';
import * as Survey from 'survey-angular';
import { Account } from '../../models/AccountModel';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { SessionService } from 'src/app/services/session.service';
import { ActivatedRoute, Router } from '@angular/router';

enum Actions {
  PREV,
  NEXT,
  DONE
}

@Component({
  selector: 'cw-ci-assessment-work',
  templateUrl: './assessment-work.component.html',
  styleUrls: ['./assessment-work.component.scss']
})
export class AssessmentWorkComponent implements OnInit {

  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @Input() account: Account;
  @Input() accountAssessment: AccountAssessment
  @Input() assmntReadOnly: boolean;
  assessment: Assessment;
  survey: Survey.Model;
  showSurveyNavigation = false;
  showAssmntFeatures :boolean;
  questionData: any[] = [];
  questionDataSet: any[] = [];
  showButton = false;

  constructor(public _platformApi: PlatformApiService, public dialog: MatDialog, public sessionService: SessionService, private _activatedRoute: ActivatedRoute, private _router: Router) {
    Survey.StylesManager.applyTheme('darkblue');
    Survey.JsonObject.metaData.addProperty('questionbase', {name: 'nistFunction:string'});
    Survey.JsonObject.metaData.addProperty('questionbase', {name: 'nistCategory:string'});
    Survey.JsonObject.metaData.addProperty('questionbase', {name: 'nistSubCategory:string' });
    Survey.JsonObject.metaData.addProperty('questionbase', {name: 'nistAssetCategory:string'});
    Survey.JsonObject.metaData.addProperty('questionbase', {name: 'helpText:string' });

    Survey.JsonObject.metaData.addProperty('itemvalue', {name: 'impactDescription:string'});
    Survey.JsonObject.metaData.addProperty('itemvalue', {name: 'remediationSteps:string'});
    Survey.JsonObject.metaData.addProperty('itemvalue', {name: 'exposureFactor:number'});
  }

  ngOnInit() {
    const self = this;
    this._platformApi.loadAssessment(this.accountAssessment.assessmentId).subscribe(assessment => {
      self.assessment = assessment;
      self.survey = new Survey.Model(this.assessment.json);
      self.survey.showNavigationButtons = false;
      self.survey.showPrevButton = false;
      self.survey.showTitle = false;
      self.survey.showPageTitles = false;
      self.survey.showCompletedPage = false;
      self.survey.showQuestionNumbers = 'off';
      self.showAssmntFeatures = true;
      if (self.assmntReadOnly){
        self.displayAssessmentResults(self.assessment)
        self.showAssmntFeatures = false;
      }

      for (const q of self.survey.getAllQuestions().filter(el => el.getType() == 'file')) {
        (q as any).allowImagesPreview = false;
        (q as any).showPreview = true;
      }

      self.survey.currentPageNo = Math.min(self.accountAssessment.currentPage, self.survey.pageCount);

      if (self.accountAssessment.surveyResultsJson) {
        self.survey.data = this.accountAssessment.surveyResultsJson;
      }

      self.showSurveyNavigation = true;
      self.survey.onComplete.add(result => self.saveAssessmentResults(Actions.DONE));

      self.survey.onAfterRenderQuestion.add((survey, options) => {
        // Return if there is no description to show in popup
        if (!options.question.helpText) {
          return;
        }

        const header = options
          .htmlElement
          .querySelector('h5');

        const span = document.createElement('span');
        span.innerText = '?';
        span.setAttribute('tooltip', options.question.helpText);
        span.setAttribute('tooltip-position', 'bottom');
        header.appendChild(span);
      });

      Survey.SurveyNG.render('surveyElement', { model: self.survey });
    });
  }

  nextPage() {
    const self = this;
    if (!self.showAssmntFeatures){
      self.survey.nextPage();
    } else {
      this.saveAssessmentResults(Actions.NEXT);
      this.stateChange.emit({state:'NEXTPAGE'});
    }
  }

  prevPage() {
    const self = this;
    if (!self.showAssmntFeatures){
      self.survey.prevPage();
    } else {
      this.saveAssessmentResults(Actions.PREV);
      this.stateChange.emit({state:'PREVPAGE'})
    }
  }

  closeSurvey() {
    this.stateChange.emit({state:'CLOSEASSESSMENT'});
  }

  getProgressPercent() {
    if (this.survey) {
      return `${Math.floor(this.survey.currentPageNo / this.survey.pageCount * 100)}%`;
    } else {
      return '0%';
    }
  }

  private saveAssessmentResults(action: Actions) {
    const self = this;
    const pageNo = self.survey.currentPageNo + ((action === Actions.NEXT || action === Actions.DONE) ? 1 : (action === Actions.PREV ? -1 : 0));

    self.accountAssessment.surveyResultsJson = self.survey.data;
    self.accountAssessment.currentPage = pageNo;
    self.accountAssessment.percentComplete = pageNo / self.survey.pageCount;
    self.accountAssessment.status = action === Actions.DONE ? AssessmentStatus.COMPLETED : AssessmentStatus.IN_PROGRESS;

    console.log(`Saving progress(pageCount=${self.survey.pageCount}, currentPageNo=${self.accountAssessment.currentPage}, percentComplete=${self.accountAssessment.percentComplete})`);

    self._platformApi.saveAccountAssessment(self.account, self.accountAssessment).subscribe(res => {
      res.assessmentName = self.accountAssessment.assessmentName;
      res.assessmentType = self.accountAssessment.assessmentType;
      self.accountAssessment = res;

      switch (action) {
        case Actions.NEXT:
          self.survey.nextPage();
          break;
        case Actions.PREV:
          self.survey.prevPage();
          break;
        case Actions.DONE:
          self.showSurveyNavigation = false;
          self.stateChange.emit({ state: 'COMPLETEDASSESSMENT', completedAssessment: self.accountAssessment });
          break;
      }
    });
  }


  buttonAction() {
    const accountAssessment = this.accountAssessment;
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptMessage: [
          'This will return the assessment to an incomplete state and require the partner to resubmit again.  Are you sure you would like to return to the partner?'
        ],
        closeLabel: 'Cancel',
        buttons: [{label:'No', value:'NO', color:'primary'}, {label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response == 'YES') {
          const newAccountAssessment = new AccountAssessment({
            id: accountAssessment.id,
            accountId: accountAssessment.accountId,
            assessmentId: accountAssessment.assessmentId,
            currentPage: 0,
            percentComplete: 0,
            status: AssessmentStatus.IN_PROGRESS,
            isLatest: accountAssessment.isLatest,
            surveyResultsJson: accountAssessment.surveyResultsJson
          });
         this._platformApi.saveAccountAssessment(undefined, newAccountAssessment).subscribe(result => {
            this._router.navigate(['../'], {relativeTo:this._activatedRoute});
        });
      }
    });
  }

  private displayAssessmentResults(assessment: Assessment) {
    const accountAssessment = this.accountAssessment;
    if(accountAssessment.isLatest && accountAssessment.status.toLowerCase() == 'completed' && this.sessionService.isAccountType('SYSTEM')) {
      this.showButton = true;
    }

    let quesObj : any;
    let assessAnsSelected :any[] = [];
    for(let i=0; i<assessment.json['pages'].length; i++ ){
      const surveyResultsJsonObjs = Object.keys(accountAssessment.surveyResultsJson);
      surveyResultsJsonObjs.forEach(function(item,index) {
        const assessAnswered = assessment.json['pages'][i].elements.filter(el =>el.name == item);
        if (assessAnswered.length>0){
          assessAnsSelected.push(assessAnswered);
        }
      })
      for(let j=0; j<assessAnsSelected.length; j++ ){
        const assessSet = assessAnsSelected[j][0];
        if (assessSet.type === 'text') {
          quesObj = {
            question: assessSet.title,
            answer: accountAssessment.surveyResultsJson[assessSet.name],
            type: 'text',
          };
        } else if(assessSet.type === 'radiogroup') {
          const value = accountAssessment.surveyResultsJson[assessSet.name]
            const choice = assessSet.choices.find(ans => ans.value === value);
            if (choice) {
              quesObj = {
                question: assessSet.title,
                answer: choice,
                type: 'radiogroup',
              };
            }
        } else if(assessSet.type === 'checkbox'){
            const value = accountAssessment.surveyResultsJson[assessSet.name]
            const choice : any[] =[];
            for(let i=0; i<value.length; i++ ){
              const dataCheckBox = assessSet.choices.find(ans => ans.value === value[i]).text
              choice.push(dataCheckBox);
            }
            if (choice) {
              quesObj = {
                question: assessSet.title,
                answer: choice,
                type: 'checkbox',
              };
            }
        }
        this.questionData.push(quesObj);
      }
    this.questionDataSet[i] ={questions: this.questionData, title: assessment.json['pages'][i].title};
    this.questionData = [];
    assessAnsSelected = [];
  }
}
}